import { apiClient } from './api';

export const businessService = {
  // Get all business packages (alias method untuk compatibility)
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        if (Array.isArray(params[key])) {
          params[key].forEach(value => queryParams.append(key, value));
        } else {
          queryParams.append(key, params[key]);
        }
      }
    });

    const queryString = queryParams.toString();
    const url = queryString ? `/business-packages?${queryString}` : '/business-packages';
    
    return await apiClient.get(url);
  },

  // Get all business packages (original method)
  getAllBusinessPackages: async (params = {}) => {
    return businessService.getAll(params);
  },

  // Create business package (alias method untuk compatibility)
  create: async (packageData) => {
    return businessService.createBusinessPackage(packageData);
  },

  // Update business package (alias method untuk compatibility)  
  update: async (id, packageData) => {
    return businessService.updateBusinessPackage(id, packageData);
  },

  // Delete business package (alias method untuk compatibility)
  delete: async (id) => {
    return businessService.deleteBusinessPackage(id);
  },

  // Get featured business packages
  getFeaturedPackages: async () => {
    return await apiClient.get('/business-packages/featured');
  },

  // Get business package by ID
  getBusinessPackageById: async (id) => {
    return await apiClient.get(`/business-packages/${id}`);
  },

  // FIXED: Create business package - Send JSON instead of FormData
  createBusinessPackage: async (packageData) => {
    console.log('🔄 BusinessService.createBusinessPackage called with:', packageData);
    
    // Send as JSON, not FormData
    const payload = {
      name: packageData.name,
      description: packageData.description,
      package_type: packageData.package_type,
      management_fee_percentage: packageData.management_fee_percentage,
      features: packageData.features, // Keep as array
      status: packageData.status,
      featured: packageData.featured
    };
    
    console.log('📤 Sending JSON payload:', payload);
    
    // Use regular POST request with JSON data
    return await apiClient.post('/business-packages', payload);
  },

  // FIXED: Update business package - Send JSON instead of FormData
  updateBusinessPackage: async (id, packageData) => {
    console.log('🔄 BusinessService.updateBusinessPackage called with:', id, packageData);
    
    // Send as JSON, not FormData
    const payload = {
      name: packageData.name,
      description: packageData.description,
      package_type: packageData.package_type,
      management_fee_percentage: packageData.management_fee_percentage,
      features: packageData.features, // Keep as array
      status: packageData.status,
      featured: packageData.featured
    };
    
    console.log('📤 Sending JSON payload for update:', payload);
    
    // Use regular PUT request with JSON data
    return await apiClient.put(`/business-packages/${id}`, payload);
  },

  // Delete business package
  deleteBusinessPackage: async (id) => {
    return await apiClient.delete(`/business-packages/${id}`);
  },

  // Get business packages by category
  getBusinessPackagesByCategory: async (category) => {
    return await apiClient.get(`/business-packages/category/${category}`);
  },

  // Toggle featured status
  toggleFeaturedStatus: async (id) => {
    return await apiClient.put(`/business-packages/${id}/featured`);
  },
};

// Named exports untuk backward compatibility
export const getAllBusinessPackages = businessService.getAllBusinessPackages;
export const getFeaturedPackages = businessService.getFeaturedPackages;
export const getBusinessPackageById = businessService.getBusinessPackageById;
export const createBusinessPackage = businessService.createBusinessPackage;
export const updateBusinessPackage = businessService.updateBusinessPackage;
export const deleteBusinessPackage = businessService.deleteBusinessPackage;
export const getBusinessPackagesByCategory = businessService.getBusinessPackagesByCategory;
export const toggleFeaturedStatus = businessService.toggleFeaturedStatus;